module.exports = __webpack_public_path__ + "img/stock1.9ac43d65.png";